import ClientRelationship from 'modules/BackOffice/containers/ClientChangesForm/ClientRelationship/ClientRelationship';

export default ClientRelationship;
